import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* fetchIncenses() {
  try {
    const spices = yield call(() => callGetAPI(SERVER_API.INCENSES));
    yield put({ type: sagaActions.INCENSES_LOAD, data: spices.data });
  } catch (e) {
    yield put({ type: sagaActions.API_FAILED, message: e.message });
  }
}

function* watchFetchIncensesAsync() {
  yield takeLatest(sagaActions.INCENSES_LOAD_REQUEST, fetchIncenses);
}

export default watchFetchIncensesAsync;
